import { Routes } from '@angular/router';
import { HomeComponent } from "./home/home.component";
import { SignInComponent } from "./auth/sign-in/sign-in.component";
import { authGuard } from "./auth/auth.guard";
import { signedInGuard } from "./auth/signed-in.guard";

export const routes: Routes = [
  { path: '', component: HomeComponent, canActivate: [authGuard] },
  { path: 'sign-in', component: SignInComponent, canActivate: [signedInGuard] },
  { path: '**', redirectTo: '' }
];
